import { Navbar } from '../components/Navbar';

export default function ResourceDetail() {
  return (
    <div className="min-h-screen bg-slate-50">
      <Navbar />
      <main className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <h1 className="text-2xl font-bold text-slate-900">Resource Detail</h1>
        <p className="text-slate-600 mt-2">Coming soon...</p>
      </main>
    </div>
  );
}
